import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as s, createElementBlock as n, normalizeClass as o, createElementVNode as d } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconPastConversations",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function _(e, t, i, u, f, a) {
  return s(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--past-conversations"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Past Conversations",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    d("path", {
      d: "M1.646 7.646a.5.5 0 1 1 .708.708L1.707 9H9a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 9 3H4.5a.5.5 0 0 0-.5.5V6a.5.5 0 1 1-1 0V3.5A1.5 1.5 0 0 1 4.5 2H9a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 9 10H1.707l.647.646a.5.5 0 1 1-.708.707l-1.5-1.5a.5.5 0 0 1 0-.707l1.5-1.5ZM7.5 7.25a.5.5 0 1 1 0 1H5a.5.5 0 0 1 0-1h2.5Zm1-1.75a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h3.5Zm0-1.75a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h3.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const H = /* @__PURE__ */ l(c, [["render", _]]);
export {
  H as default
};
//# sourceMappingURL=past-conversations.js.map
